<template>
    <div>
        <div class="full-vs-sidebar email-view-sidebar items-no-padding">
            <div class="mail-sidebar-content px-0 pb-3 h-full">
                <div style="border-radius: 5px;" class="flex justify-between items-center email-header px-4 pb-4 pt-4 d-theme-dark-bg fixed_position">
                    <div class="flex">
                        <feather-icon
                            @click="back_list"
                            icon="ArrowLeftIcon"
                            class="cursor-pointer mr-4"
                            svg-classes="w-6 h-6"/>
                        <ListView :item="GET_DESCRIPTION_DETAIL"/>
                    </div>
                    <div>
                        <vx-tooltip :text="$t('history')" position="left" class="flex items-center">
                            <feather-icon
                                @click="showHistory"
                                class="cursor-pointer ml-3"
                                icon="RotateCcwIcon"
                                svg-classes="w-6 h-6"/>
                        </vx-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <vs-card>
            <vs-tabs alignment="fixed">
                <vs-tab :label="$t('journal')">
                    <journal/>
                </vs-tab>
                <vs-tab :label="$t('description')">
                    <description/>
                </vs-tab>
            </vs-tabs>
        </vs-card>
        <vs-popup fullscreen class="holamundo" :title="$t('history')" :active.sync="historyPopup">
            <ElectronicJournalHistory />
        </vs-popup>
    </div>
</template>

<script>
import Journal from "@/pages/Home/ElectronicJournal/Detail/Tabs/Journal";
import Description from "@/pages/Home/ElectronicJournal/Detail/Tabs/Description";
import ListView from "@/pages/Home/ElectronicJournal/ListView";
import CancellationHistory from "@/pages/Home/ElectronicJournal/Detail/Tabs/Popup/CancellationHistory";
import ElectronicJournalHistory from "./Tabs/Popup/ElectronicJournalHistory"
import { mapActions, mapGetters } from "vuex";
export default {
    name: "Detail",
    components: {
        Description,
        Journal,
        ListView,
        CancellationHistory,
        ElectronicJournalHistory

    },
    data(){
        return {
            cancellationHistoryPopup: false,
            historyPopup: false
        }
    },
    computed:{
        ...mapGetters({
            GET_DESCRIPTION_DETAIL:'electronic_journal/GET_DESCRIPTION_DETAIL',
            GET_GRADING_SYSTEM_CONTROL_FORM:'electronic_journal/GET_GRADING_SYSTEM_CONTROL_FORM',
        })
    },
    methods:{
        ...mapActions({
            STUDENT_DETAIL:'electronic_journal/STUDENT_DETAIL',
            DATE_DETAIL:'electronic_journal/DATE_DETAIL',
            MARK_DETAIL:'electronic_journal/MARK_DETAIL',
            CO_TEACHERS_FOR_COURSE:'final_grades/CO_TEACHERS_FOR_COURSE',
            MARK:'final_grades/MARK',
            DESCRIPTION_DETAIL:'electronic_journal/DESCRIPTION_DETAIL',
            GRADING_SYSTEM_CONTROL_FORM:'electronic_journal/GRADING_SYSTEM_CONTROL_FORM',
            REASONS_FOR_MISSING:'electronic_journal/REASONS_FOR_MISSING',
            JOURNAL_BLOCK_UNBLOCK:'electronic_journal/JOURNAL_BLOCK_UNBLOCK',
            FINAL_GRADES_FOR_BLOCK:'electronic_journal/FINAL_GRADES_FOR_BLOCK',
        }),
        showHistory(){
            let payload = {}
            payload.lesson = this.$route.query.lesson
            this.$store.dispatch('electronic_journal/fetchHistory', payload)
            this.historyPopup = true
        },
        showCancellationHistory(){
            let payload = {}
            payload.teacher = this.GET_DESCRIPTION_DETAIL.teacher.uid
            payload.lesson = this.$route.query.lesson
            this.$store.dispatch('electronic_journal/fetchCancellationHistory', payload)
            this.cancellationHistoryPopup = true
        },
        back_list(){
            let route = {...this.$route.query}
            delete route['lesson']
            delete route['course']
            delete route['electronic_journal']
            this.$router.replace({ name: 'electronic_journal', query: route });
        },
    },
    async created() {
        await this.FINAL_GRADES_FOR_BLOCK(this.$route.query)
        await this.STUDENT_DETAIL(this.$route.query)
        await this.JOURNAL_BLOCK_UNBLOCK(this.$route.query)
        await this.DATE_DETAIL(this.$route.query)
        await this.MARK_DETAIL(this.$route.query)
        // await this.CO_TEACHERS_FOR_COURSE(this.$route.query)
        await this.DESCRIPTION_DETAIL(this.$route.query)
        let control_form = this.GET_DESCRIPTION_DETAIL.course.control_form
        await this.GRADING_SYSTEM_CONTROL_FORM({...this.$route.query, control_form:control_form})
        let grading_system = this.GET_GRADING_SYSTEM_CONTROL_FORM.grading_system
        await this.MARK({...this.$route.query,grading_system:grading_system?grading_system.uid:null})
        await this.REASONS_FOR_MISSING(this.$route.query)
    },
};
</script>

<style lang="scss">
.vs-sidebar--items{
    /* Задача Не видно ячеек занятий при выборе расписания занятий курса - 4554 */
    overflow: visible!important;
}
.fixed_position{
    position: sticky!important;
    top: 0px;
    z-index: 10000;
}
.full-vs-sidebar .vs-sidebar{
    max-width:100% !important;
}

.lang_chip{
    .text-chip{
        text-transform: capitalize;
    }
}
.files_content{
    .vs-collapse-item--header{
        padding: 0px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 13px;
        .icon-header{
            position: relative;
            right: inherit;
            top: initial;
            margin: 0px;
            transform: initial;
        }
    }
    .vs-collapse{
        padding: 0px;
    }
    .vs-collapse-item--content{
        background-color: #f8f8f8;
        border-radius: 5px;
        margin-top: 8px;
    }
    .open-item{
        .icon-header{
            transform: rotate(180deg)!important;
        }
    }
}
.scroll-area-emcfull-content{
    position: relative;
    width: 100%;
    height: calc(100% - 35px);
    .archive_link{
        color: #ffffff!important;
    }
}
@media only screen and (max-width: 900px) {
    .scroll-area-emcfull-content{
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
    .email-view-sidebar{
        .emc_view_date{
            .justify-end {
                justify-content: flex-start!important;
            }
            .text-right{
                text-align: left!important;
            }
        }
        .vx-card__collapsible-content{
            margin: 0 -20px;
        }
        .con-vs-chip{
            .text-chip{
                font-size: 10px;
            }
        }
        .email-header{
            h4{
                font-size: 15px;
            }
        }
        .vx-card__body{
            .d-theme-border-grey-light{
                display: block!important;
            }
        }
    }
}
</style>

